import React from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import TeacherNotes from "./TeacherNotes";
import UploadedNotes from "./UploadedNotes";

function TeacherNote() {
  let {path} = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={TeacherNotes} />
      <Route exact path={`${path}/uploaded-notes`} component={UploadedNotes} />
    </Switch>
  );
}

export default TeacherNote;